export default "__VITE_ASSET__DjPOe6lW__";